import { ReactElement } from 'react';
import styles from '../SpecialistExperienceData.module.scss';
import { Button } from '../../../../1_shared/ui';

interface IExpandBtnProps {
  dataLength: number;
  minCountForShow: number;
  isOpened: boolean;
  method: () => void;
}

const ExpandBtn = ({
  dataLength,
  minCountForShow,
  isOpened,
  method,
}: IExpandBtnProps): ReactElement => (
  <>
    {dataLength > minCountForShow && !isOpened && (
      <div className={styles.expandButton}>
        <Button type="secondary" className={styles.btnOpen} onClick={method}>
          {dataLength === 1 ? 'ПОДРОБНЕЕ' : `+${dataLength - minCountForShow}`}
        </Button>
      </div>
    )}
    {isOpened && (
      <div className={styles.expandButton}>
        <Button type="secondary" className={styles.btnClose} onClick={method}>
          СВЕРНУТЬ
        </Button>
      </div>
    )}
  </>
);

export default ExpandBtn;
